import { useCallback } from 'react';

export function usePageNavigation() {
  const navigate = useCallback((item) => {
    if (item.href) {
      window.location.assign(item.href);
      return;
    }

    document.getElementById(item.target)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }, []);

  return { navigate };
}
